import React, { useState } from 'react';
import './Profile.css';
import user from '../data/saikut.jpg';
import User from '../User/User';
import Swal from 'sweetalert2';
import BreakTime from '../BreakTime/BreakTime';
import { addToLocalStorage, showDataFromLocalStorage } from '../utilities/utilities';
import { useEffect } from 'react';

const Profile = (props) => {
    const { time } = props;

    //now setting break time to ui
    const [breakTime, setBreakTime] = useState(0);
    const breakMinutes = [10, 25, 32, 58];
    const addToBreak = (min) => {
        setBreakTime(min);
        addToLocalStorage(min);
    }

    //get data from local storage for show in ui

    useEffect(() => {
        const minsFromLocalStorage = showDataFromLocalStorage();
        setBreakTime(minsFromLocalStorage);
    }, [])


    return (

        <div className='profile shadow-2xl flex flex-col align-middle justify-center'>
            <div className='user-container'>
                {/* Name, photo address and details of User */}
                <User user={user}></User>
                {/* Minute break section */}
                <div className='bg-gray-400 rounded-lg flex flex-col justify-center align-middle p-3'>
                    <p className='text-2xl font-bold text-center my-1'>Add a break</p>
                    <div className='flex justify-around break-mins'>
                        {
                            breakMinutes.map(min =>
                                <BreakTime
                                    min={min}
                                    addToBreak={addToBreak}
                                    key={min}
                                ></BreakTime>)
                        }

                    </div>
                </div>

                {/* Activities Details */}
                <div className='my-5'>
                    <h1 className='text-2xl text-center'>Activities Details</h1>
                    <div className='flex justify-around my-3 bg-gray-300 p-2 rounded-lg'>
                        <p className='font-bold'>Activity Time:</p>
                        <p><span>{time}</span> min</p>
                    </div>
                    <div className='flex justify-around my-3 bg-gray-300 p-2 rounded-lg'>
                        <p className='font-bold'>Break Time:</p>
                        <p><span>{breakTime}</span> min</p>
                    </div>

                </div>

                <button className="btn btn-outline btn-primary w-[95%] mx-auto" onClick={() => {
                    Swal.fire(
                        'Good job!',
                        'Activity Completed.',
                        'success'
                    )
                }}>Activity Complete</button>
            </div>
        </div>

    );
};

export default Profile;